import i18n from "@/i18n";
import { nextTick } from "vue";

const Trans = {
  get defaultLocale() {
    return process.env.VUE_APP_I18N_LOCALE;
  },

  get supportedLocales() {
    const locales = process.env.VUE_APP_SUPPORTED_LOCALS;
    return locales ? locales.split(",") : [];
  },

  get locale(): string {
    return String(i18n.global.locale.value);
  },

  set currentLocale(newLocale: string) {
    i18n.global.locale.value = newLocale as "en" | "ru" | "zh";
  },

  isLocaleSupported(locale: string): boolean {
    return Trans.supportedLocales.includes(locale);
  },

  getUserLocale() {
    const locale = window.navigator.language || Trans.defaultLocale;
    return {
      locale: locale,
      localeNoRegion: locale ? locale.split("-")[0] : "",
    };
  },

  getPersistentLocale(): string | null {
    const persistentLocale = localStorage.getItem("lang");
    if (persistentLocale && Trans.isLocaleSupported(persistentLocale))
      return persistentLocale;
    else return null;
  },

  guessDefaultLocale(): string | undefined {
    const userPersistentLocale = Trans.getPersistentLocale();
    if (userPersistentLocale) return userPersistentLocale;

    const userPreferredLocale = Trans.getUserLocale();
    const locale = userPreferredLocale.locale;
    if (Trans.isLocaleSupported(locale ? locale : "")) return locale ? locale : "";
    if (Trans.isLocaleSupported(userPreferredLocale.localeNoRegion))
      return userPreferredLocale.localeNoRegion;

    return Trans.defaultLocale;
  },

  async switchLanguage(newLocale: string): Promise<void> {
    await Trans.loadLocaleMessages(newLocale);
    Trans.currentLocale = newLocale;
    localStorage.setItem("lang", newLocale);
    const html = document.querySelector("html");
    if (html) html.setAttribute("lang", newLocale);
  },

  async loadLocaleMessages(locale: string): Promise<void> {
    if (!Object.keys(i18n.global.availableLocales).includes(locale)) {
      const message = await import(`@/i18n/locales/${locale}.json`);
      i18n.global.setLocaleMessage(locale, message.default);
    }
    return nextTick();
  },
};

export default Trans;
